export const deliverySelect = [
  { title: 'Самовывоз', code: 'self' },
  { title: 'Доставка', code: 'delivery_yandex' },
];
